export const geocodeAddressClient = async (fullAddress) => {
  const response = await fetch(
    'https://us-central1-just-like-home-6df9f.cloudfunctions.net/geocodeAddress',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ address: fullAddress }),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Geocoding failed');
  }

  const data = await response.json();
  return data;
};